import { makeStyles } from 'tss-react/mui';

export const useDarkModeStyles = makeStyles()(() => ({
    darkMode: {
        backgroundColor: '#1a1a2e',
        color: '#e0e0e0',
        minHeight: '100vh',
        '& .card': {
            backgroundColor: '#16213e',
            color: '#e0e0e0',
            borderColor: '#0f3460',
        },
        '& .card-header': {
            backgroundColor: '#0f3460',
            color: '#e0e0e0',
            borderColor: '#0f3460',
        },
        '& .card-body': {
            backgroundColor: '#16213e',
            color: '#e0e0e0',
        },
        '& .list-group-item': {
            backgroundColor: '#16213e',
            color: '#e0e0e0',
            borderColor: '#0f3460',
        },
        '& .btn-primary': {
            backgroundColor: '#0f3460',
            borderColor: '#0f3460',
        },
        '& .btn-primary:hover': {
            backgroundColor: '#1a4b8c',
            borderColor: '#1a4b8c',
        },
        '& .btn-outline-primary': {
            color: '#5dade2',
            borderColor: '#5dade2',
        },
        '& .btn-outline-primary:hover': {
            backgroundColor: '#5dade2',
            color: '#1a1a2e',
        },
        '& .table': {
            color: '#e0e0e0',
            '--bs-table-bg': '#16213e',
            '--bs-table-striped-bg': '#1a2744',
            '--bs-table-hover-bg': '#1e2f50',
            borderColor: '#0f3460',
        },
        '& .modal-content': {
            backgroundColor: '#16213e',
            color: '#e0e0e0',
            borderColor: '#0f3460',
        },
        '& .modal-header': {
            borderColor: '#0f3460',
        },
        '& .modal-footer': {
            borderColor: '#0f3460',
        },
        '& .form-control': {
            backgroundColor: '#0f3460',
            color: '#e0e0e0',
            borderColor: '#1a4b8c',
        },
        '& .form-control:focus': {
            backgroundColor: '#0f3460',
            color: '#e0e0e0',
            borderColor: '#5dade2',
            boxShadow: '0 0 0 0.25rem rgba(93, 173, 226, 0.25)',
        },
        '& .form-select': {
            backgroundColor: '#0f3460',
            color: '#e0e0e0',
            borderColor: '#1a4b8c',
        },
        '& .container, & .container-fluid': {
            color: '#e0e0e0',
        },
        '& h1, & h2, & h3, & h4, & h5, & h6': {
            color: '#e0e0e0',
        },
        '& a': {
            color: '#5dade2',
        },
        '& .badge.bg-success': {
            backgroundColor: '#1e8449 !important',
        },
        '& .badge.bg-warning': {
            backgroundColor: '#b7950b !important',
        },
        '& .badge.bg-danger': {
            backgroundColor: '#922b21 !important',
        },
        '& .alert-info': {
            backgroundColor: '#0f3460',
            color: '#5dade2',
            borderColor: '#1a4b8c',
        },
        '& .alert-warning': {
            backgroundColor: '#4a3728',
            color: '#f0c75e',
            borderColor: '#6b5230',
        },
        '& .alert-danger': {
            backgroundColor: '#4a2828',
            color: '#f5b7b1',
            borderColor: '#6b3030',
            '& h1, & h2, & h3, & h4, & h5, & h6': {
                color: '#f5b7b1',
            },
        },
        '& .btn-close': {
            filter: 'invert(1)',
        },
        '& .accordion-item': {
            backgroundColor: '#16213e',
            color: '#e0e0e0',
            borderColor: '#0f3460',
        },
        '& .accordion-button': {
            backgroundColor: '#16213e',
            color: '#e0e0e0',
        },
        '& .accordion-button:not(.collapsed)': {
            backgroundColor: '#0f3460',
            color: '#e0e0e0',
        },
        '& .dropdown-menu': {
            backgroundColor: '#16213e',
            borderColor: '#0f3460',
        },
        '& .dropdown-item': {
            color: '#e0e0e0',
        },
        '& .dropdown-item:hover': {
            backgroundColor: '#0f3460',
            color: '#e0e0e0',
        },
        '& .text-muted': {
            color: '#8e99a4 !important',
        },
        '& .border': {
            borderColor: '#0f3460 !important',
        },
    },
    darkModeModal: {
        '& .modal-content': {
            backgroundColor: '#16213e',
            color: '#e0e0e0',
            borderColor: '#0f3460',
            border: '1px solid #0f3460',
        },
        '& .modal-header': {
            borderColor: '#0f3460',
        },
        '& .modal-header.border': {
            borderColor: '#0f3460 !important',
        },
        '& .modal-footer': {
            borderColor: '#0f3460',
        },
        '& .modal-footer.border': {
            borderColor: '#0f3460 !important',
        },
        '& .modal-body': {
            color: '#e0e0e0',
        },
        '& .btn-close': {
            filter: 'invert(1)',
        },
    },
}));
